// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CollapseComponent} from './Collapse.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCollapse = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CollapseComponent/>
  </Icon>
));
